import { entity } from "simpler-state"
import { api_fetch } from "@/api/client.tsx"
import { OrgFieldConfig } from "@/api/org_field_config.tsx"
import { MonthClose } from "@/api/month_close.tsx"

interface IOrgConfigState {
  orgFieldConfigs: OrgFieldConfig[]
  orgFieldConfigsLoaded: boolean
  /** The org's recorded month-end close dates, earliest first (drive the Month-End Close List column). */
  monthCloses: MonthClose[]
}

const INITIAL_ORG_CONFIG_STATE: IOrgConfigState = {
  orgFieldConfigs: [],
  orgFieldConfigsLoaded: false,
  monthCloses: [],
}

export const OrgConfigState = entity(INITIAL_ORG_CONFIG_STATE)

let org_field_configs_load_promise: Promise<void> | null = null

export async function loadOrgFieldConfigs() {
  if (OrgConfigState.get().orgFieldConfigsLoaded) {
    return
  }
  if (org_field_configs_load_promise) {
    return org_field_configs_load_promise
  }

  org_field_configs_load_promise = (async () => {
    const [result, closes] = await Promise.all([
      api_fetch<OrgFieldConfig[]>("/org-field-configs"),
      api_fetch<MonthClose[]>("/month-closes"),
    ])
    if (closes.ok) {
      setMonthCloses(closes.value.data)
    }
    if (result.ok) {
      OrgConfigState.set(state => ({
        ...state,
        orgFieldConfigs: result.value.data,
        orgFieldConfigsLoaded: true,
      }))
    } else {
      OrgConfigState.set(state => ({
        ...state,
        orgFieldConfigsLoaded: true,
      }))
    }
  })()

  return org_field_configs_load_promise
}



/** Replace the cached close dates (after the settings page saves or deletes one). */
export function setMonthCloses(monthCloses: MonthClose[]) {
  OrgConfigState.set(state => ({ ...state, monthCloses }))
}
